import React, { useEffect } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { clearProductSort } from 'demo/store/product.reducer'
import { clearUserSort, setUserSort } from 'demo/store/user.reducer'
import { setJobSort, setJobColumnSort } from 'demo/store/jobReducer'
import {
    setReportColumnSort,
    setReportHistorySort,
    setReportSort,
} from 'demo/store/reportReducer'
import Badge from '../Badge'
import { getNewOrderCount } from 'demo/store/commonReducer'
import {
    setFilterBrand,
    setFilterCategory,
    setFilterModel,
    setFilterSearch,
    setFilterYear,
} from 'demo/store/cartReducer'
import {
    setPromotionSort,
    setSentPromotionSort,
    setUsedPromotionSort,
} from 'demo/store/promotionReducer'
import { clearServiceSort, getPendingCount } from 'demo/store/service.reducer'
import { clearSettingSort } from 'demo/store/setting.reducer'

const MenuItem = React.forwardRef((props, ref) => {
    const dispatch = useDispatch()
    const { accessRole } = useSelector((state) => state.common)
    const { pendingCount } = useSelector((state) => state.service)

    const {
        asElement: Component,
        children,
        className,
        disabled,
        eventKey,
        isActive,
        menuItemHeight,
        onSelect,
        style,
        variant,
        collapse,
        ...rest
    } = props

    const menuItemActiveClass = `menu-item-active`
    const menuItemHoverClass = `menu-item-hoverable`
    const disabledClass = 'menu-item-disabled'
    const menuItemClass = classNames(
        'menu-item',
        `menu-item-${variant}`,
        isActive && menuItemActiveClass,
        disabled && disabledClass,
        !disabled && menuItemHoverClass,
        className
    )

    const currentYear = new Date().getFullYear()

    const hanldeOnClick = (e) => {
        if (onSelect) {
            onSelect(eventKey, e)
        }

        if (eventKey === 'service.consignment') {
            dispatch(getPendingCount())
        }

        dispatch(clearProductSort())
        dispatch(clearUserSort())
        dispatch(clearSettingSort())
        dispatch(clearServiceSort())

        // dispatch(
        //     setPackageSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 5,
        //         total: 0,
        //         search: '',
        //         body_type: '',
        //     })
        // )

        // dispatch(
        //     setAlacarteSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 5,
        //         total: 0,
        //         search: '',
        //         body_type: '',
        //     })
        // )

        // dispatch(
        //     setAccessoriesSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //     })
        // )

        // dispatch(
        //     setReportSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         search: '',
        //         total: 0,
        //         type: 'operation user',
        //         user_id: '',
        //         start_date: '',
        //         end_date: '',
        //         payment_slip: 'no',
        //     })
        // )

        // dispatch(
        //     setReportHistorySort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         search: '',
        //         total: 0,
        //         user_id: '',
        //         installer_name: '',
        //         type:
        //             localStorage.getItem('role') === 'salesman'
        //                 ? 'salesman'
        //                 : localStorage.getItem('role') ===
        //                   'salesman_with_operation'
        //                 ? 'salesman_with_operation'
        //                 : 'operation user',
        //         start_date: '',
        //         end_date: '',
        //         payment_slip: 'yes',
        //     })
        // )

        // dispatch(
        //     setOtherSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //     })
        // )

        // dispatch(setFilterSort({}))
        // dispatch(setReportColumnSort({}))
        // dispatch(setJobColumnSort({}))

        // dispatch(
        //     setJobSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //         status: null,
        //         start_date: '',
        //         end_date: '',
        //     })
        // )

        // dispatch(
        //     setUserSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //         type:
        //             accessRole === 'admin'
        //                 ? 'operation'
        //                 : accessRole === 'superadmin'
        //                 ? 'admin'
        //                 : 'user',
        //     })
        // )

        // dispatch(
        //     setPromotionSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //     })
        // )

        // dispatch(
        //     setSentPromotionSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //         start_date: '',
        //         end_date: '',
        //     })
        // )

        // dispatch(
        //     setUsedPromotionSort({
        //         activePage: 1,
        //         start: 0,
        //         length: 10,
        //         total: 0,
        //         search: '',
        //         start_date: '',
        //         end_date: '',
        //     })
        // )
    }

    return (
        <Component
            ref={ref}
            className={menuItemClass}
            style={{
                height: `${menuItemHeight}px`,
                ...style,
            }}
            onClick={hanldeOnClick}
            {...rest}
        >
            {children}
            {!collapse &&
                (eventKey === 'service.consignment' ||
                    eventKey === 'service.inspection') &&
                pendingCount?.[
                    eventKey === 'service.consignment'
                        ? 'consignment'
                        : 'inspection'
                ]?.pending > 0 && (
                    <Badge
                        content={
                            pendingCount[
                                eventKey === 'service.consignment'
                                    ? 'consignment'
                                    : 'inspection'
                            ].pending
                        }
                        innerClass="bg-red-600"
                    />
                )}
        </Component>
    )
})

MenuItem.defaultProps = {
    asElement: 'div',
    menuItemHeight: 35,
    variant: 'light',
}

MenuItem.propTypes = {
    asElement: PropTypes.string,
    menuItemHeight: PropTypes.number,
    disabled: PropTypes.bool,
    isActive: PropTypes.bool,
    eventKey: PropTypes.string,
    variant: PropTypes.oneOf(['light', 'dark', 'themed', 'transparent']),
}

export default MenuItem
